'use client';

import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import Image from 'next/image';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

/**
 * SectionPaket Component
 * Rafting package carousel section with Swiper
 */
const SectionPaket: React.FC = () => {
  const [activeProgressIndex, setActiveProgressIndex] = useState(0);
  const [swiperInstance, setSwiperInstance] = useState<any>(null);

  const paketData = [
    {
      id: 1,
      image: '/assets/images/paket/pekalen-atas2.webp',
      title: 'Pekalen Atas',
      description: [
        'Jarak 12 km',
        'Start Dusun Angin-angin, Finish Dusun Gembleng Desa Ranugedang',
        'Grade 2 – 3+',
        'Melewati 7 air terjun dan lebih dari 50 jeram',
        'Point of Interest : Pekalen Swing dan Air Terjun Tirai Bidadari'
      ],
      price: [
        'Domestik Rp 340.000,-/ orang',
        'Internasional Rp 450.000,-/ orang'
      ]
    },
    {
      id: 2,
      image: '/assets/images/paket/pekalen-bawah.webp',
      title: 'Pekalen Bawah',
      description: [
        'Jarak 14 km',
        'Start Desa Pesawahan Kec. Tiris, Finish Desa Brebe Kec. Maron',
        'Point Of Interest : Jeram God Bless'
      ],
      price: [
        'Domestik Rp 300.000,-/ orang',
        'Internasional Rp 400.000,-/ orang'
      ]
    },
    {
      id: 3,
      image: '/assets/images/paket/pekalen-penginapan2.webp',
      title: 'Penginapan',
      description: [
        'Kamar AC',
        'Outdoor TV',
        'Air Mineral',
        'Breakfast'
      ],
      price: [
        'Domestik Rp 550.000,-/ kamar',
        'Keterangan: Bisa Muat Max 5 Orang'
      ]
    },
    {
      id: 4,
      image: '/assets/images/paket/paintball2.webp',
      title: 'Paint Ball',
      description: [
        'Individual shooting target',
        'Wargame',
        'Durasi waktu 1 – 2 jam'
      ],
      price: [
        'Rp 150.000,- /pax'
      ]
    },
    {
      id: 5,
      image: '/assets/images/paket/swing.webp',
      title: 'Swing',
      description: [
        'Lokasi : Air Terjun Tirai Bidadari',
        'Tinggi 10 meter',
        'Bisa ditempuh dengan kendaraan lokal atau rafting'
      ],
      price: [
        'Free bagi pengguna wisata arung jeram PEKALEN RAFTING',
        'Rp 35.000,-/ orang untuk pengunjung umum'
      ]
    },
    {
      id: 6,
      image: '/assets/images/paket/outbound-training.webp',
      title: 'Outbound Training',
      description: [
        'Program team building untuk meningkatkan produktivitas melalui kepercayaan, pemecahan masalah, dan komunikasi tim.',
        'Berbasis experiential learning, mencakup teamwork, character building, leadership, dan pengembangan sumber daya manusia.'
      ],
      price: []
    },
    {
      id: 7,
      image: '/assets/images/paket/bukit-candi.webp',
      title: 'Wisata Bukit Candi',
      description: [
        'Meski baru dikembangkan, Bukit Candi cepat menarik wisatawan pencinta tantangan dan panorama alam.',
        'Berada di ketinggian sekitar 1.326 mdpl, tersedia camping ground, spot selfie berlatar Gunung Tarub dan Gunung Lemongan, serta panorama sunrise dan sunset yang menawan.',
        'Cocok untuk rekreasi santai, melepas penat, dan berburu foto.'
      ],
      price: []
    }
  ];

  return (
    <div className="lg:py-12 lg:px-0 md:px-0 md:py-8 px-6 py-6 flex flex-col gap-12 items-center bg-white max-w-6xl mx-auto">
      <div className="w-full flex flex-col items-center relative">
        {/* Section Header */}
        <h2 className="font-bold text-[24px] md:text-[40px] text-center leading-normal tracking-[0.4px] text-[#222222] md:mb-16 mb-4">
          Paket yang Siap Anda Jual
        </h2>

        {/* Swiper Carousel */}
        <div className="w-full font-family-open-sans relative ">
          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={16}
            slidesPerView={3}
            loop={true}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            navigation={{
              nextEl: '.swiper-button-next-custom',
              prevEl: '.swiper-button-prev-custom',
            }}
            onSwiper={setSwiperInstance}
            onSlideChange={(swiper) => {
              // Calculate which progress segment should be active
              const totalSegments = 3;
              const slidesPerSegment = Math.ceil(paketData.length / totalSegments);
              const currentSegment = Math.floor(swiper.realIndex / slidesPerSegment);
              setActiveProgressIndex(Math.min(currentSegment, totalSegments - 1));
            }}
            breakpoints={{
              0: {
                slidesPerView: 1,
                spaceBetween: 16,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 16,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 16,
              },
            }}
            className="paket-swiper !px-2 !pb-6"
          >
              {paketData.map((paket) => (
                <SwiperSlide key={paket.id}>
                  <div className="bg-neutral-50 border-[6px] border-white overflow-hidden h-full flex flex-col shadow-md">
                    {/* Package Image */}
                  <div className="w-full lg:h-100 md:h-70 h-75 relative">
                                        <Image
                                          src={paket.image}
                                          alt={paket.title}
                                          fill
                                          className="object-cover object-bottom"
                                          quality={85}
                                        />
                      {/* Wave SVG Overlay */}
                      {/* <div className="absolute bottom-0 left-0 right-0 w-full">
                        <svg viewBox="0 0 322.668 80" preserveAspectRatio="none" className="w-full h-auto" style={{display: 'block'}}>
                          <path d="M0,30 Q40,50 80,30 T160,30 T240,30 T322.668,30 L322.668,80 L0,80 Z" fill="#fafafa"/>
                        </svg>
                      </div> */}
                    </div>

                    {/* Package Content */}
                    <div className="p-4 flex flex-col gap-2 flex-1">
                      <h3 className="font-bold lg:text-[32px] md:text-[20px] text-[20px] tracking-[-0.32px] text-[#222222] mb-2">
                        {paket.title}
                      </h3>

                      {/* Description List */}
                      <div className="flex flex-col lg:text-[16px] md:text-[14px] text-[13px] gap-1 mb-2">
                        <p className="font-bold text-[#222222] mb-1">Description:</p>
                        <ul className="list-disc pl-6 space-y-1">
                          {paket.description.map((item, index) => (
                            <li key={index} className="leading-7 text-[#4a5565]">
                              {item}
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* Price */}
                      {paket.price.length > 0 ? (
                        <div className="mt-auto flex flex-col lg:text-[16px] md:text-[14px] text-[13px] gap-1">
                          <p className="font-bold text-[#222222] mb-1">Price:</p>
                          <ul className="list-disc pl-6 space-y-1">
                            {paket.price.map((item, index) => (
                              <li key={index} className="leading-7 text-[#4a5565]">
                                {item}
                              </li>
                            ))}
                          </ul>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>
        </div>

        {/* Mobile Navigation Buttons - Below Slider */}
        <div className="flex md:hidden justify-center items-center gap-4 mt-6">
          <button
            onClick={() => swiperInstance?.slidePrev()}
            className="bg-[#000000] rounded-full w-12 h-12 flex items-center justify-center hover:bg-black/90 transition-all duration-200 cursor-pointer"
            aria-label="Previous package"
          >
            <Icon icon="solar:arrow-left-bold" className="text-white" fontSize={20} />
          </button>
          <button
            onClick={() => swiperInstance?.slideNext()}
            className="bg-[#000000] rounded-full w-12 h-12 flex items-center justify-center hover:bg-black/90 transition-all duration-200 cursor-pointer"
            aria-label="Next package"
          >
            <Icon icon="solar:arrow-right-bold" className="text-white" fontSize={20} />
          </button>
        </div>

        {/* Custom Pagination Progress Bars - Desktop/Tablet Only */}
        <div className="hidden md:flex justify-center items-center gap-6 mt-8">
          {[0, 1, 2].map((index) => (
            <button
              key={index}
              onClick={() => {
                if (swiperInstance) {
                  const slidesPerSegment = Math.ceil(paketData.length / 3);
                  const targetSlide = index * slidesPerSegment;
                  swiperInstance.slideToLoop(targetSlide);
                }
              }}
              className={`w-32 h-2 rounded-[46px] transition-all duration-300 cursor-pointer hover:opacity-80 ${
                index === activeProgressIndex ? 'bg-[#222222]' : 'bg-[#d9d9d9]'
              }`}
              aria-label={`Go to section ${index + 1}`}
            />
          ))}
        </div>

        {/* Desktop Navigation Buttons - Side Positioned */}
        <button
          className="swiper-button-prev-custom absolute left-0 top-[45%] -translate-y-1/2 z-20 bg-[#000000] rounded-full w-12 h-12 hidden md:flex items-center justify-center hover:bg-black/90 transition-all duration-200 cursor-pointer"
          aria-label="Previous package"
        >
          <Icon icon="solar:arrow-left-bold" className="text-white" fontSize={20} />
        </button>

        <button
          className="swiper-button-next-custom absolute right-0 top-[45%] -translate-y-1/2 z-20 bg-[#000000] rounded-full w-12 h-12 hidden md:flex items-center justify-center hover:bg-black/90 transition-all duration-200 cursor-pointer"
          aria-label="Next package"
        >
          <Icon icon="solar:arrow-right-bold" className="text-white" fontSize={20} />
        </button>
      </div>

    </div>
  );
};

export default SectionPaket;